<p *ngIf="titlePresent && descriptionPresent" class="productDescription">
    <span style="font-weight: bold" [innerHTML]="title"></span>&nbsp;
    <span *ngIf="descriptionPresent" [innerHTML]="description"><br /><br/></span>
</p>
<span *ngIf="titlePresent && !descriptionPresent" class="productDescription">
    <span style="font-weight: bold" [innerHTML]="title"></span>
</span>
<p *ngIf="!titlePresent && descriptionPresent" [innerHTML]="description" class="productDescription"><br /><br/></p>
